module.exports = __webpack_public_path__ + "img/day12.3f4d1d0b.svg";